__turbopack_context__.v({
  "className": "inter_5288e911-module__9ZNk0q__className",
});
